<template>
  <ui-container>
    <ui-row>
      <ui-col col="12">
        <h3 class="page-title">用户管理</h3>
      </ui-col>
      <ui-col col="12">
        <user-list></user-list>
      </ui-col>
      <ui-col col="12">
        <h3 class="page-title">添加用户</h3>
        <add-user></add-user>
      </ui-col>
    </ui-row>

  </ui-container>
</template>
<script>
import { mapGetters } from "vuex";
import api from '../api/index.js'
import UserList from './components/userList.vue'
import AddUser from './components/addUser.vue'
export default {

  name: 'index',

  data() {
    return {

    }
  },
  computed: {
    ...mapGetters(["authInfo"]),
  },
  components: {
    UserList,
    AddUser
  },
  mounted() {


  }
}

</script>
